import { api } from "@/shared/libs/axiosClient";

export interface SlackDefaultChannel {
  channel_id: string | null;
  channel_name: string | null;
}

export async function fetchSlackDefaultChannel(): Promise<SlackDefaultChannel> {
  return api.get<SlackDefaultChannel>("/slack/default-channel");
}
